import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Page, Group, Layout, Button, Grid } from "@/comn/components"; // 화면 구성 컴포넌트
import { useFetch, useGrid, usePage } from "@/comn/hooks"; // hook
import { URLS, APIS, SG_RECC_DTL_LIST } from "./services/OsciBllReccService"; // 서비스

/*
 * Reconciliation History Detail
 * !== 정산 처리 이력 상세 ==!
 */
export const OSCI0406010Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    });
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const { rqstId } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Reconciliation History Detail List Grid !== 정산 처리 이력 상세 목록 그리드 ==!
        reccDtlList: useGrid({
            defaultSchema: SG_RECC_DTL_LIST,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Reconciliation History Detail List !== 정산 처리 이력 상세 목록 조회 ==!
        getReccDtlList: useFetch({
            api: () => {
                if (!rqstId) return;
                return APIS.getReccDtlList(rqstId);
            },
            enabled: !!rqstId,
            key: [rqstId],
            showToast: true,
        }),
    };

    const render = {
        grid_ReccDtlList: {
            cell: {
                bllNo: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return `${rowValues.bllNo}(${rowValues.grpBllNo})`;
                },
            },
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        fetch.getReccDtlList.fetch();
    }, [rqstId]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.reccDtlList.grid}
                            data={fetch.getReccDtlList.data?.reccDtlList}
                            render={render.grid_ReccDtlList}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>

            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.osci0406009q);
                        }}
                    ></Button>
                </Layout.Left>
            </Layout>
        </Page>
    );
};
